// extracted by mini-css-extract-plugin
export default {"ag-styles":"bz_g","version":"bz_QT"};